import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaHandshake, FaAward, FaUsers, FaClock } from 'react-icons/fa';
import './About.css';

const About = () => {
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  const values = [
    {
      icon: <FaAward />,
      title: 'Quality',
      description: 'We never cut corners. Every product we deliver is tested, clean, and built to last.',
    },
    {
      icon: <FaHandshake />,
      title: 'Trust',
      description: 'We are honest, we communicate clearly, and we do what we say we will do.',
    },
    {
      icon: <FaUsers />,
      title: 'Team',
      description: 'Our experienced team is here to listen, understand your needs, and bring your idea to life.',
    },
    {
      icon: <FaClock />,
      title: 'On Time',
      description: 'We respect your time. Projects are planned carefully and delivered on schedule, every time.',
    },
  ];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.12 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } },
  };

  return (
    <section className="about" id="about" ref={ref}>
      <div className="about__container">
        <motion.div
          className="about__header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <span className="section-tag">Who We Are</span>
          <h2 className="section-title">
            A Team You Can
            <br />
            <span className="text-green">Rely On.</span>
          </h2>
          <p className="section-description">
            KAT99 Pvt Ltd is a group of companies based in Sri Lanka. Our
            software division builds digital solutions — apps, websites, and
            enterprise systems — delivered on time and within budget.
          </p>
        </motion.div>

        <motion.div
          className="about__values"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
        >
          {values.map((val, i) => (
            <motion.div className="about__value-card" key={i} variants={itemVariants}>
              <div className="about__value-icon">{val.icon}</div>
              <h3>{val.title}</h3>
              <p>{val.description}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="about__cta-row"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <div className="about__cta-card">
            <div className="about__cta-number">01</div>
            <div>
              <h4>Software & Apps</h4>
              <p>Mobile apps, websites, POS systems, loyalty programs and any custom software your business needs.</p>
            </div>
          </div>
          <div className="about__cta-divider" />
          <div className="about__cta-card">
            <div className="about__cta-number">02</div>
            <div>
              <h4>More Than Software</h4>
              <p>KAT99 is a group of companies. Use the <strong>Our Groups</strong> menu in the navbar to explore our other divisions.</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
